import { AnimatePresence, motion } from "framer-motion";
import parse from "html-react-parser";
import React from "react";

import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";

import Button from "@atoms/Button";
import Icon from "@atoms/Icon";

import type { ISubModal } from "@store/layout";
import { useLayoutStore } from "@store/layout";

export default function SubModal() {
  const { isPC } = useCheckDevice();
  const { subModal, closeSubModal } = useLayoutStore();

  const handleCloseSubModal = (subModalData: ISubModal) => {
    if (subModalData?.id === "notice" && subModalData?.handle) {
      localStorage.setItem(subModalData.handle, JSON.stringify(new Date().getTime() + 24 * 60 * 60 * 1000));
    }

    window.location.hash = "";

    closeSubModal();
  };

  return (
    <AnimatePresence>
      {subModal.length ? (
        <motion.article
          animate={{ x: 0, y: 0, transition: { ease: [0.1, 0, 0.05, 1], duration: 0.2 } }}
          className="pc:w-full-grid-cols-4 pc:bottom-5 pc:left-5 pc:gap-5 pc:p-5 fixed bottom-4 left-4 z-20 flex w-[calc(100%-2rem)] flex-col gap-4 bg-neutral-100/95 p-4 break-all shadow lg:w-1/4 dark:bg-black/98 dark:text-white dark:shadow-white"
          exit={{ x: isPC ? "-100%" : 0, y: isPC ? 0 : "100%" }}
          initial={{ x: isPC ? "-100%" : 0, y: isPC ? 0 : "100%" }}
          key={subModal[0].id}
          transition={{ ease: [0.1, 0, 0.05, 1], duration: 0.2 }}
        >
          <div className="flex justify-between gap-5">
            <h3 className="capitalize">{subModal[0].title}</h3>
            <Button
              as="text"
              onClick={() => {
                handleCloseSubModal(subModal[0]);
              }}
            >
              {isPC ? "Close" : <Icon className="size-3.5" name="Close" />}
            </Button>
          </div>
          <div>{typeof subModal[0].content === "string" ? parse(subModal[0].content) : subModal[0].content}</div>
        </motion.article>
      ) : null}
    </AnimatePresence>
  );
}
